import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import Home from "./pages/Home";

function App() {
  return (
    <LanguageProvider>
      <Home />
      <Toaster position="top-center" richColors toastOptions={{ className: "font-sans" }} />
    </LanguageProvider>
  );
}

export default App;
